{
  "en": {
    "help": {
      "headings": {
        "additionalModelsNote": "In addition, there are further models available - with varying capacities.",
        "contact": "You didn’t find an answer to your question?",
        "contactSubtitle": "Please get in touch - we’re happy to help you out.",
        "currentTextModels": "Current Language Models",
        "free": "Your test quota for creating tools for free",
        "imageModels": "Image Models",
        "imageModelsIntro": "These models can generate images from text descriptions.",
        "ttsModels": "Text-to-Speech Models",
        "ttsModelsIntro": "These models can convert text into natural-sounding speech.",
        "transcriptionModels": "Transcription Models",
        "transcriptionModelsIntro": "These models can transcribe audio recordings into text.",
        "languageModelIntro": "Fobizz offers a variety of AI models, always integrating the most current and powerful options available. These models must comply with our data protection requirements and provide sufficient capacity to meet fobizz's demands. Since new models are released by providers at irregular intervals, there is no fixed schedule - we evaluate each new model promptly and integrate it as soon as the aforementioned requirements are met.",
        "languageModelVideoIntro": "Which model is right for my task?",
        "languageModelVideoDescription": "In the following video, we explain the differences between open and closed models, fast small models and powerful reasoning models — and when each model is the best choice.",
        "languageModels": "Language Models",
        "largeModel": "A Large Model",
        "largeModelDescription": "This model provides more detailed responses and is well-suited for requests that require greater depth and the processing of larger contexts.",
        "limits": "Limits",
        "modelCards": "Overview of AI Models",
        "modelTypesIntro": "Fobizz prefers open models and recommends two alternatives in the AI Chat, in the following order:",
        "openSourceLanguageModels": "Open Source Language Models",
        "plugins": "Plugins",
        "proprietaryLanguageModels": "Proprietary Language Models",
        "reasoningModel": "A Reasoning Model",
        "reasoningModelDescription": "Known for its exceptional analytical capabilities, this model is best for complex tasks that involve multi-step logical thinking and conclusions.",
        "references": "References",
        "searchResults": "Search Results",
        "smallModel": "A Small Model",
        "smallModelDescription": "This model is particularly fast and efficient, making it ideal for quick dialogues, content-related tasks, and straightforward answers.",
        "subtitle": "Advice and answers from the fobizz team",
        "welcome": "Welcome to the fobizz help center"
      },
      "chatbot": {
        "title": "Ask our FAQ Chatbot",
        "description": "Ask our chatbot any question you may have. It can provide you with information on all topics related to fobizz and the digital AI tools.",
        "url": "https://app.fobizz.com/ai/chats/public_assistants/9b5806f8-3c2d-49bf-a10f-2dc27e8bb8f3?token=442d9042d15a2986a36cc80645348101"
      },
      "labels": {
        "articles": "0 Article | 1 Article | {count} Articles",
        "contextWindow": "Context Window",
        "input": "Input",
        "knowledgeCutoff": "Knowledge Cutoff",
        "lastUpdated": "Last updated on",
        "maxTokens": "Max Tokens",
        "modelCardUrl": "Reference Documentation",
        "opensInNewTab": "opens in new tab",
        "reasoning": "Reasoning",
        "recommended": "Recommended",
        "searchResults": "Questions & Answers"
      },
      "links": {
        "allCategories": "All Categories",
        "backToHelp": "Back to help"
      },
      "paragraphs": {
        "contactEmail": "Write us an email",
        "contactPhone": "Call us: Mo to Fr 8-16",
        "contactSales": "Schedule a consultation",
        "contactSchoolLicense": "For advice on school licenses",
        "disclaimer": "All language models listed here are hosted in European or German/European data centers - with the exception of the models from OpenAI and Anthropic.",
        "intro": "With the free version of the fobizz tools you can use all tools. However, the amount of content you can create is limited as follows.",
        "outro": "All the content you have created will remain accessible even when your subscription or school license ends. You can find detailed information on the conditions of the various fobizz offers in the <a href=\"https://plattform.fobizz.com/preistabelle\" target=\"_blank\">pricing table</a>",
        "plugins": "All models compatible with plugins automatically have access to the following integrations. The plugins can significantly enhance the capabilities of AI assistants.",
        "recommendedForHelp": "The suggestions are based on your <a href=\"{profileSettingsUrl}\" target=\"_blank\">profile settings</a>.<br>Feel free to customise them."
      },
      "search": {
        "noResults": "No exact matches for your search. Please try a different keyword or spelling."
      },
      "table": {
        "contextWindow": "Context Window",
        "featureNames": "Feature names",
        "maxTokens": "Max Tokens",
        "model": "Model",
        "openSource": "Open",
        "provider": "Provider",
        "reasoning": "Reasoning",
        "supportsFunctions": "Plugins",
        "supportsVision": "Image processing",
        "supportsImageGeneration": "Generation",
        "sizes": "Sizes"
      }
    }
  }
}
